import { render, staticRenderFns } from "./AggregateStatistics.vue?vue&type=template&id=006675b8&scoped=true&"
import script from "./AggregateStatistics.vue?vue&type=script&lang=js&"
export * from "./AggregateStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AggregateStatistics.vue?vue&type=style&index=0&id=006675b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006675b8",
  null
  
)

export default component.exports